import { useEffect } from "react";
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar/SideBar';
import Navbar from './login/DashNav';



const DashboardLayout: React.FC = () => {

    useEffect(() => {
    // Add a class to <body> when dashboard mounts
    document.body.classList.add("dashboard-body");

    // Remove it when leaving the dashboard
    return () => {
      document.body.classList.remove("dashboard-body");
    };
  }, []);

  return (
    <div className="grid-container bg-color">
      <div className="flex-row gap-0">
        <Sidebar />
        <div className="w-100 grid-padding-lr">
          <Navbar />
          <div className="ptb-2">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
